import { Badge } from "react-bootstrap";
import FlagDropdown from "./FlagDropDown"; // Update the path based on your project structure

export const tableConstants = (
  permissions,
  redirectQueryDetails,
  viewHandler,
  page,
  activeMenuRow,
  setActiveMenuRow,
  subTypeList,
  subTypeChangeHandler,

) => {
  let count = 1;

  return [
    {
      title: 'SrNo.',
      render: () => <span>{(50 * (page - 1)) + count++}</span>,
    },
    {
      title: 'Query_No',
      render: rowData => <span>{rowData.id}</span>,
    },
    {
      title: 'Admission_No',
      render: rowData => <span>{rowData.id_number}</span>,
    },
    {
      title: 'Student_Name',
      render: rowData => <span className="text-capitalize">{rowData.student_name}</span>,
    },
    {
      title: 'class',
      render: rowData => <span className="text-capitalize">{rowData.student_class}</span>,
    },
    {
      title: 'Request_Type',
      render: rowData => <div className="text-capitalize">{rowData.request_type}
      </div>,
    },
    {
      title: 'Request_SubType',
      render: rowData => (<span className="text-capitalize">{rowData.request_sub_type?.name || "N/A"}
        <FlagDropdown
          rowId={rowData.id}
          activeMenuRow={activeMenuRow}
          setActiveMenuRow={setActiveMenuRow}
          list={(subTypeList && subTypeList.find((item) => item.name === rowData.request_type)?.sub_types) || []}
          onChangeHandler={subTypeChangeHandler}
        />
      </span>),
    },
    {
      title: 'School',
      render: rowData => <span className="text-capitalize">{rowData.school_name}</span>,
    },
    {
      title: 'father_email',
      render: rowData => <span>{rowData.stakeholder_email}</span>,
    },
    {
      title: 'Status',
      render: rowData => (
        <Badge
          className={`${rowData.reply_status === 0 ? "bg-success" : ""}
                    ${rowData.reply_status === 1 ? "bg-danger" : ""}
                    ${rowData.reply_status === 2 ? "bg-warning" : ""}
                    ${rowData.reply_status === 3 ? "bg-info" : ""}
          text-uppercase`}>
          {rowData.reply_status === 0 ? "OPEN" : ""}
          {rowData.reply_status === 1 ? "CLOSED" : ""}
          {rowData.reply_status === 2 ? "CLOSED and follow-up required" : ""}
          {rowData.reply_status === 3 ? "ACKNOWLEDGED" : ""}
        </Badge>
      ),
    },
    {
      title: 'Request_received',
      render: rowData => <span>{rowData.created_at}</span>,
    },
    {
      title: 'ReadBy',
      render: rowData => <span>{rowData.read_user && rowData.read_user.name}</span>,
    },
    {
      title: 'Read_On',
      render: rowData => <span>{rowData.read_date}</span>,
    },
    {
      title: 'Replied_By',
      render: rowData =>
        rowData.replies.length > 0 &&
          rowData.replies[0].is_draft === 0 &&
          rowData.replies[0].reply_user?.name ? (
          <span>{rowData.replies[0].reply_user.name}</span>
        ) : null,
    },
    {
      title: 'Replied_On',
      render: rowData =>
        rowData.replies.length > 0 &&
          rowData.replies[0].is_draft === 0 ? (
          <span>{rowData.replies[0].created_at}</span>
        ) : null,
    },
    {
      title: 'View',
      render: rowData => (
        <button
          className="reply-btn"
          onClick={() => viewHandler(rowData, "view")}
          style={{ color: "var(--color-link)" }}
        >
          view
        </button>
      ),
    },
    ...(permissions?.includes("stakeholder.query.reply")
      ? [
        {
          title: 'Reply',
          render: rowData =>
            (!rowData.replies.length || rowData.replies[0].is_draft === 1) && (
              <button
                className="reply-btn"
                onClick={() => redirectQueryDetails(rowData.id, "reply")}
                style={{
                  color: ((rowData.replies.length > 0 &&
                    rowData.replies[0].is_draft === 1) ? "var(--color-warning)" : "var(--color-link)"), background: "var(--color-surface)"
                }}
              >
                {rowData.replies.length > 0 && rowData.replies[0].is_draft === 1 ? "Draft" : "Reply"}
              </button>
            ),
        },
      ]
      : []),
  ];
};
